import * as React from "react";
import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";

/********************************
<Spotlight />
/********************************
Version: 2
Created: 22 01 2025
Updated: 22 01 2025s
Author: Richy Pears
/********************************
Displays the spotlight component
/********************************/

const Spotlight = ({ blok }) => {
  if (!blok) return null; // Escape hatch
  const { copy, ctas, number, rounded, subtitle, theme, title } = blok;

  const colour = SmartColour(theme);

  return (
    <section
      className={`py-12 md:py-24 px-5 ${
        colour.classes && colour.classes
      } ${SmartStyles("rounded", rounded)}`}
    >
      <div className="brand-container p-5 md:p-10 py-8 md:py-12 rounded-2xl bg-white/5 shadow-mega brand-bg-blur flex flex-col gap-6 md:gap-12">
        <SectionNumber title={subtitle && subtitle} number={number && number} />
        {copy && (
          <SmartText className="m-0 text-center brand-remove-last-margin">
            {copy}
          </SmartText>
        )}
      </div>
    </section>
  );
};

export default Spotlight;
